import { Component, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CustomerResponse } from 'src/app/shared/models/customer';
import { channels } from 'src/app/shared/constants/channels';
import { CustomerService } from 'src/app/core/services/customer.service';
import { ReportTabBase } from '../report-tab.base';

@Component({
    selector: 'app-customer-report',
    templateUrl: './customer-report.component.html',
    styleUrl: '../report-tab.scss',
})
export class CustomerReportComponent extends ReportTabBase {
    private readonly customerService = inject(CustomerService);

    readonly salesChannels = channels;
    readonly form = new FormGroup({
        startDate: new FormControl(),
        endDate: new FormControl(),
        channel: new FormControl(),
    });

    reports: CustomerResponse[] = [];

    submit(): void {
        const value = this.form.getRawValue();
        const payload = {
            startDate: value.startDate ? this.toReportDate(value.startDate) : null,
            endDate: value.endDate ? this.toReportDate(value.endDate) : null,
            channel: value.channel ? value.channel : null,
        };

        this.startLoading('Fetching customers');
        this.customerService.generateCustomerReports(payload).subscribe({
            next: (response) => {
                this.stopLoading();
                this.reports = response['customers'];
            },
            error: (err) => {
                this.stopLoading();
                this.showError(err.error.message);
            },
        });
    }

    export(): void {
        this.exportTable('Customers_Report');
    }
}
